import { render, staticRenderFns } from "./PsReportsItem.vue?vue&type=template&id=5dceea2b&scoped=true&"
import script from "./PsReportsItem.vue?vue&type=script&lang=js&"
export * from "./PsReportsItem.vue?vue&type=script&lang=js&"
import style0 from "./PsReportsItem.vue?vue&type=style&index=0&id=5dceea2b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dceea2b",
  null
  
)

export default component.exports